/** FK alanından sayısal id çıkarır (obje, id veya string). */
export function fkId(value) {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === "object") {
        const id = value.id ?? value.pk;
        return id === undefined || id === null ? null : id;
    }
    const n = Number(value);
    return Number.isNaN(n) ? value : n;
}
